import { Controller, useFormContext } from 'react-hook-form'

import { phoneTypeTypes } from 'commons/types/dictionaries'
import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const PhoneType = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.phoneNumbers.${index2 as 0}.phoneType`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="20. Type"
          input={(props) => (
            <Select {...props} emptyOption={{ label: 'Not selected', value: '' }} data={phoneTypeTypes} />
          )}
        />
      )}
    />
  )
}
